import { AllowList } from 'sections/onsite-campaigns/types';
import { DomainRule, IsInFlowService } from '../../types';

export interface IpAddressOnlyRequiredForDisplayWebContentRuleDto {
  allowList: AllowList[];
  isInFlowService: IsInFlowService;
}

export const IpAddressOnlyRequiredForDisplayWebContentRuleKey = 'ipAddressRequired';

/**
 * IP Address allow list is only required if Display web content has been added to
 * the workflow.
 */
export const IpAddressOnlyRequiredForDisplayWebContentRule = (
  dto: IpAddressOnlyRequiredForDisplayWebContentRuleDto,
): DomainRule => {
  const isDisplayWebContentInFlow = !!dto.isInFlowService.isDisplayWebsiteContentInFlow();

  if (!isDisplayWebContentInFlow) {
    return {
      result: 'pass',
      ruleKey: null,
    };
  }

  if (!dto.allowList || !dto.allowList.length) {
    return {
      result: 'fail',
      ruleKey: IpAddressOnlyRequiredForDisplayWebContentRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
